import { etapasEnum, etapasIndexEnum } from '@util/defaultValues';
import { getCurrentLanguage } from '../../helpers';
const inicialState = {
  lang: getCurrentLanguage(),
  rtf: null,
  idRtf: 0,
  showCarregando: false,
  filtrosExterno: [],
  closeCarregando: false,
  splash: false,
  showModal: false,
  mensagemAlerta: null,
  listagemTotal: 0,
  listagemExibido: 0,
  etapa: { etapa: etapasEnum.MATERIAL, tab: etapasIndexEnum.MATERIAL },
  loadListagem: false,
  idAlerta: 0,
  pagina: 1,
  tipoAlerta: 'info',
  timeoutAlerta: 2000,
  totalMensagens: 0,
  totalCertificadosPendentes: 0,
  timeoutTotalMensagens: null,
  textoProtocoloEntregaMaterial: '',
  modalMensagens: false,
  modalCertificacaoDigital: false,
  atalho: undefined,
  medPadraoFat: undefined,
  fatMedicoPadrao: undefined,
  filtros: [],
  favoritos: [],
  listagem: [],
  medicos: [],
  coloracoes: [],
  antigenos: [],
  impressoras: [],
  exameVincular: undefined,
  exames: [],
  frascosGravados: [],
  frascosNovos: [],
  altura: 75,
  detalhes: undefined,
  inconformidades: [],
  editorInicializado: false,
  historicoInconformidades: [],
  modalRecolhimentoMulti: false,
  modalEntrega: false,
  modalFaturamento: false,
  laudoFaturado: false,
  laudoEntrega: undefined,
  modalImprimir: false,
  laudoImprimir: undefined,
  laudoSelecionado: undefined,
  editorCarregado: false,
  showEditor: false,
  textoInicial: false,
  autosaveEditor: false,
  etapaAtual: undefined,
  laudarEtapaRequest: undefined,
  larguraEditor: '100%',
  totalNaoConformidades: 0,
  minWidth: '350px',
  exameFinalizado: false,
  exameEntregue: false,
  ordenacao: 1,
  sentidoOrdenacao: true,
  grupoUsuarios: [],
  bloquearRecebimento: false,
  plainTextLaudo: undefined,
  fecharTela: false,
  draggablePanelContent: undefined,
  draggablePanelTitle: undefined,
  listagemRastreabilidade: [],
  medicoPadraoMacroscopia: undefined,
  eventokeyUpFoiDisparadoNoEditor: false,
  listagemDocumentosExternos: [],
  modalObservacoes: false,
  modalSoul: false,
  autoSaveAtivo: true,
  modalRequisicaoImuno: false,
  visibilidadeListaLaminas: false,
  visibilidadeLaudosAnteriores: false,
  listagemMultiplosExames: [],
  visibilidadeAutotexto: false,
  visibilidadeFrascos: false,
  visibilidadeListagemAnexo: false,
  visibilidadeHistoricoLaudo: false,
  visibilidadeDetalhesExame: false,
  visibilidadeMultiplosExame: false,
  atualizaAutotexto: false,
  dadosGeraisHospital: { razaosoc: '' },
  quantidadeLaudosAnteriores: 0,
  usuarios: []
};
export default inicialState;



// WEBPACK FOOTER //
// ./src/app/common/common.state.js